export const emulsifiantsHeaders = [
  "code",
  "ingredient",
  "ingredient_note",
  "technofunctionality",
  "suppliers",
  "source_category",
  "sector",
  "product_platform",
  "product_type_alpha",
  "chemical_composition",
  "chemical_composition_standardized",
  "chemical_structure",
  "chemical_name_iupac",
  "preparation_and_extraction",
  "extraction_yield_percentage",
  "solubility_note",
  "solubility_category",
  "solubility_in_water",
  "polarity",
  "stability_ph_notes",
  "stability_ph_standardized",
  "stability_temperature_note",
  "stability_temperature_standardized",
  "stability_light",
  "stability_low_concentration",
  "stability_high_concentration",
  "stability_unit",
  "unnamed_label_alpha",
  "optimal_amount",
  "low_quantity_with_unit",
  "high_quantity_with_unit",
  "low_quantity",
  "high_quantity",
  "quantity_in_what",
  "product_type_beta",
  "optimal_quantity_with_unit",
  "optimal_quantity",
  "optimal_quantity_in_what",
  "oil_percentage_in_optimal_quantity_with_unit",
  "oil_percentage_in_optimal_quantity",
  "product_type_gamma",
  "test_method",
  "results_statement",
  "ph_stability",
  "ph_stability_conditions",
  "heat_stability",
  "heat_stability_conditions",
  "salt_stability",
  "salt_stability_conditions",
  "freeze_thaw_stability",
  "freeze_thaw_stability_conditions",
  "efficacy1",
  "efficacy1_unit",
  "efficacy1_parameter",
  "efficacy1_level",
  "eff_parameter1",
  "efficacy1_conditions",
  "efficacy2",
  "efficacy2_unit",
  "efficacy2_parameter",
  "efficacy2_level",
  "eff_parameter2",
  "efficacy2_conditions",
  "efficacy3",
  "efficacy3_unit",
  "efficacy3_parameter",
  "efficacy3_level",
  "eff_parameter3",
  "efficacy3_conditions",
  "efficacy4",
  "efficacy4_unit",
  "efficacy4_parameter",
  "efficacy4_level",
  "eff_parameter4",
  "efficacy4_conditions",
  "efficacy5",
  "efficacy5_unit",
  "efficacy5_parameter",
  "efficacy5_level",
  "eff_parameter5",
  "efficacy5_conditions",
  "efficacy6",
  "efficacy6_unit",
  "efficacy6_parameter",
  "efficacy6_level",
  "eff_parameter6",
  "efficacy6_conditions",
  "efficacy7",
  "efficacy7_unit",
  "efficacy7_parameter",
  "efficacy7_level",
  "eff_parameter7",
  "efficacy7_conditions",
  "efficacy8",
  "efficacy8_unit",
  "efficacy8_parameter",
  "efficacy8_level",
  "eff_parameter8",
  "efficacy8_conditions",
  "efficacy9",
  "efficacy9_unit",
  "efficacy9_parameter",
  "efficacy9_level",
  "eff_parameter9",
  "efficacy9_conditions",
  "efficacy10",
  "efficacy10_unit",
  "efficacy10_parameter",
  "efficacy10_level",
  "eff_parameter10",
  "efficacy10_conditions",
  "efficacy11",
  "efficacy11_unit",
  "efficacy11_parameter",
  "efficacy11_level",
  "eff_parameter11",
  "efficacy11_conditions",
  "efficacy12",
  "efficacy12_unit",
  "efficacy12_parameter",
  "efficacy12_level",
  "eff_parameter12",
  "efficacy12_conditions",
  "efficacy13",
  "efficacy13_unit",
  "efficacy13_parameter",
  "efficacy13_level",
  "eff_parameter13",
  "efficacy13_conditions",
  "efficacy14",
  "efficacy14_unit",
  "efficacy14_parameter",
  "efficacy14_level",
  "eff_parameter14",
  "efficacy14_conditions",
  "efficacy15",
  "efficacy15_unit",
  "efficacy15_parameter",
  "efficacy15_level",
  "eff_parameter15",
  "efficacy15_conditions",
  "efficacy16",
  "efficacy16_unit",
  "efficacy16_parameter",
  "efficacy16_level",
  "eff_parameter16",
  "efficacy16_conditions",
  "efficacy17",
  "efficacy17_unit",
  "efficacy17_parameter",
  "efficacy17_level",
  "eff_parameter17",
  "efficacy17_conditions",
  "efficacy18",
  "efficacy18_unit",
  "efficacy18_parameter",
  "efficacy18_level",
  "eff_parameter18",
  "efficacy18_conditions",
  "efficacy19",
  "efficacy19_unit",
  "efficacy19_parameter",
  "efficacy19_level",
  "eff_parameter19",
  "efficacy19_conditions",
  "emulsifying_stability",
  "emulsifying_activity_index",
  "interfacial_tension",
  "droplet_size",
  "effect_on_taste",
  "taste",
  "phase",
  "other_technofunctionality",
  "use",
  "surface_load_of_emulsifier",
  "link",
  "doi",
  "first_author",
  "authors",
  "year",
  "journal",
  "volume_and_issue",
  "title",
  "short_link",
  "abstract",
  "hyperlink",
];

export const antimicrobienHeaders = [
  "code",
  "#",
  "technofunctionality",
  "ingredient_note",
  "ingredient",
  "suppliers",
  "source_category",
  "sector",
  "product_platform",
  "product_type_alpha",
  "chemical_composition",
  "chemical_composition_standardized",
  "chemical_structure",
  "chemical_name_iupac",
  "solubility_note",
  "extraction_yield_percentage",
  "solubility_in_water",
  "solubility_category",
  "polarity",
  "stability_ph_note",
  "stability_ph_standardized",
  "stability_temperature_note",
  "stability_temperature_standardized",
  "stability_light",
  "stability_low_concentration",
  "stability_high_concentration",
  "stability_unit",
  "product_type_beta",
  "low_quantity",
  "high_quantity",
  "product_type_gamma",
  "optimal_quantity",
  "microorganism",
  "group_of_microorganisms",
  "test_method",
  "efficacy_note",
  "growth_inhibition",
  "time",
  "growth_inhibition_percentage",
  "log_reduction",
  "mic",
  "inhibition_zone",
  "efficacy1_unit",
  "eff_parameter1_unit",
  "efficacy1",
  "eff_parameter1",
  "efficacy1_level",
  "efficacy2_note",
  "efficacy2_unit",
  "eff_parameter2_unit",
  "efficacy2",
  "eff_parameter2",
  "efficacy2_level",
  "efficacy3_note",
  "efficacy3_unit",
  "eff_parameter3_unit",
  "efficacy3",
  "eff_parameter3",
  "efficacy3_level",
  "effect_on_taste",
  "taste",
  "phase",
  "other_technofunctionality",
  "link",
  "first_author",
  "authors",
  "year",
  "journal",
  "volume_and_issue",
  "title",
  "short_link",
  "abstract",
  "notes",
  "label_name_abbreviation",
];

export const antioxidantHeaders = [
  "code",
  "technofunctionality",
  "ingredient_note",
  "ingredient",
  "suppliers",
  "source_category",
  "sector",
  "product_platform",
  "product_type_alpha",
  "chemical_composition",
  "chemical_composition_standardized",
  "chemical_structure",
  "chemical_name_iupac",
  "solubility_note",
  "extraction_yield_percentage",
  "solubility_in_water",
  "solubility_category",
  "unnamed_label_beta",
  "polarity",
  "stability_ph_note",
  "stability_ph_standardized",
  "stability_temperature_note",
  "stability_temperature_standardized",
  "stability_light",
  "stability_low_concentration",
  "stability_high_concentration",
  "stability_unit",
  "product_type_beta",
  "low_quantity",
  "high_quantity",
  "product_type_gamma",
  "optimal_quantity",
  "test_method",
  "log_reduction",
  "growth_inhibition",
  "time",
  "growth_inhibition_percentage",
  "microorganism_abbreviation",
  "microorganism",
  "group_of_microorganisms",
  "effect_summary",
  "efficacy_note",
  "mic",
  "inhibition_zone",
  "parameter1_unit",
  "parameter1_value",
  "parameter2_unit",
  "parameter2_value",
  "parameter3_unit",
  "parameter3_value",
  "parameter4_unit",
  "parameter4_value",
  "efficacy1",
  "eff_parameter1",
  "efficacy1_level",
  "efficacy2",
  "eff_parameter2",
  "efficacy2_level",
  "efficacy3",
  "eff_parameter3",
  "efficacy3_level",
  "effect_on_taste",
  "taste",
  "phase",
  "other_technofunctionality",
  "link",
  "first_author",
  "authors",
  "year",
  "journal",
  "volume_and_issue",
  "title",
  "short_link",
  "abstract",
  "relevant_focus1",
  "relevant_focus2",
  "relevant_focus3",
  "relevant_focus3",
];

export const sugarHeaders = [
  "#",
  "technofunctionality",
  "ingredient",
  "ingredient_note",
  "suppliers",
  "source_category",
  "sector",
  "product_platform",
  "product_type_alpha",
  "chemical_composition",
  "chemical_composition_standardized",
  "chemical_structure",
  "chemical_name_iupac",
  "extraction_yield_note",
  "extraction_yield_percentage",
  "solubility_note",
  "solubility_category",
  "solubility_in_water",
  "polarity",
  "stability_ph_note",
  "stability_ph_standardized",
  "stability_temperature_note",
  "stability_temperature_standardized",
  "stability_light",
  "stability_low_concentration",
  "stability_high_concentration",
  "stability_unit",
  "optimal_amount",
  "low_quantity",
  "high_quantity",
  "quantity_in_what",
  "product_type_beta",
  "optimal_quantity",
  "optimal_quantity_in_what",
  "product_type_gamma",
  "test_method",
  "mechanism",
  "results_statement",
  "efficacy1",
  "eff_parameter1",
  "efficacy1_uniform_parameter",
  "efficacy1_level",
  "efficacy2",
  "eff_parameter2",
  "efficacy2_uniform_parameter",
  "efficacy2_level",
  "efficacy3",
  "eff_parameter3",
  "efficacy3_uniform_parameter",
  "efficacy3_level",
  "efficacy4",
  "eff_parameter4",
  "efficacy4_uniform_parameter",
  "efficacy4_level",
  "efficacy5",
  "eff_parameter5",
  "efficacy5_uniform_parameter",
  "efficacy5_level",
  "efficacy6",
  "eff_parameter6",
  "efficacy6_uniform_parameter",
  "efficacy6_level",
  "uniform_parameter_color",
  "uniform_parameter_color_level",
  "uniform_parameter_taste",
  "uniform_parameter_taste_level",
  "uniform_parameter_texture",
  "uniform_parameter_texture_level",
  "uniform_parameter_acceptability",
  "uniform_parameter_acceptability_level",
  "uniform_parameter_hardness",
  "uniform_parameter_hardness_level",
  "uniform_parameter_other_textural_prop",
  "uniform_parameter_other_textural_prop_level",
  "uniform_parameter_viscosity",
  "uniform_parameter_viscosity_level",
  "uniform_parameter_water_activity",
  "uniform_parameter_water_activity_level",
  "uniform_parameter_water_absorption",
  "uniform_parameter_water_absorption_level",
  "uniform_parameter_microbiological_params",
  "uniform_parameter_microbiological_params_level",
  "uniform_parameter_brix",
  "uniform_parameter_brix_level",
  "uniform_parameter_chemical_composition",
  "uniform_parameter_chemical_composition_level",
  "effect_on_taste",
  "taste",
  "use",
  "link",
  "first_author",
  "authors",
  "year",
  "journal",
  "volume_and_issue",
  "title",
  "short_link",
  "abstract",
];

export const fatHeaders = [
  "code",
  "technofunctionality",
  "ingredient_note",
  "ingredient",
  "suppliers",
  "source_category",
  "sector",
  "product_platform",
  "product_type_alpha",
  "chemical_composition",
  "chemical_composition_standardized",
  "chemical_structure",
  "chemical_name_iupac",
  "extraction_yield_note",
  "extraction_yield_percentage",
  "solubility_note",
  "solubility_category",
  "solubility_in_water",
  "polarity",
  "stability_ph_note",
  "stability_ph_standardized",
  "stability_temperature_note",
  "stability_temperature_standardized",
  "stability_light",
  "stability_low_concentration",
  "stability_high_concentration",
  "stability_unit",
  "optimal_amount",
  "low_quantity",
  "high_quantity",
  "product_tested",
  "product_type_beta",
  "optimal_quantity",
  "optimal_quantity_in_what",
  "product_type_gamma",
  "substitution_percentage",
  "substitution_level",
  "test_method",
  "microorganism_or_mechanism",
  "microorganism",
  "group_of_microorganisms",
  "results_statement",
  "efficacy1.1",
  "eff_parameter1.1",
  "efficacy2.1",
  "eff_parameter2.1",
  "efficacy3.1",
  "eff_parameter3.1",
  "efficacy4.1",
  "eff_parameter4.1",
  "efficacy5.1",
  "eff_parameter5.1",
  "efficacy6.1",
  "eff_parameter6.1",
  "efficacy7.1",
  "eff_parameter7.1",
  "efficacy8.1",
  "eff_parameter8.1",
  "efficacy9.1",
  "eff_parameter9.1",
  "efficacy10.1",
  "eff_parameter10.1",
  "efficacy11.1",
  "eff_parameter11.1",
  "efficacy11.1",
  "eff_parameter12.1",
  "efficacy12.1",
  "eff_parameter13.1",
  "efficacy13.1",
  "eff_parameter14.1",
  "efficacy14.1",
  "eff_parameter15.1",
  "efficacy15.1",
  "eff_parameter16.1",
  "efficacy16.1",
  "eff_parameter17.1",
  "efficacy17.1",
  "eff_parameter18.1",
  "efficacy18.1",
  "eff_parameter19.1",
  "efficacy19.1",
  "eff_parameter20.1",
  "efficacy20.1",
  "eff_parameter21.1",
  "efficacy21.1",
  "eff_parameter22.1",
  "efficacy22.1",
  "eff_parameter23.1",
  "efficacy1",
  "eff_parameter1",
  "eff_parameter_standardize1",
  "postive_negative_efficacy1",
  "efficacy1_level",
  "efficacy2",
  "eff_parameter2",
  "eff_parameter_standardize2",
  "postive_negative_efficacy2",
  "efficacy2_level",
  "efficacy3",
  "eff_parameter3",
  "eff_parameter_standardize3",
  "postive_negative_efficacy3",
  "efficacy3_level",
  "efficacy4",
  "eff_parameter4",
  "eff_parameter_standardize4",
  "postive_negative_efficacy4",
  "efficacy4_level",
  "efficacy5",
  "eff_parameter5",
  "eff_parameter_standardize5",
  "postive_negative_efficacy5",
  "efficacy5_level",
  "efficacy6",
  "eff_parameter6",
  "eff_parameter_standardize6",
  "postive_negative_efficacy6",
  "efficacy6_level",
  "efficacy7",
  "eff_parameter7",
  "eff_parameter_standardize7",
  "postive_negative_efficacy7",
  "efficacy7_level",
  "efficacy8",
  "eff_parameter8",
  "eff_parameter_standardize8",
  "postive_negative_efficacy8",
  "efficacy8_level",
  "efficacy9",
  "eff_parameter9",
  "eff_parameter_standardize9",
  "postive_negative_efficacy9",
  "efficacy9_level",
  "efficacy10",
  "eff_parameter10",
  "eff_parameter_standardize10",
  "postive_negative_efficacy10",
  "efficacy10_level",
  "efficacy11",
  "eff_parameter11",
  "eff_parameter_standardize11",
  "postive_negative_efficacy11",
  "efficacy11_level",
  "efficacy12",
  "eff_parameter12",
  "eff_parameter_standardize12",
  "postive_negative_efficacy12",
  "efficacy12_level",
  "efficacy13",
  "eff_parameter13",
  "eff_parameter_standardize13",
  "postive_negative_efficacy13",
  "efficacy13_level",
  "efficacy14",
  "eff_parameter14",
  "eff_parameter_standardize14",
  "postive_negative_efficacy14",
  "efficacy14_level",
  "efficacy15",
  "eff_parameter15",
  "eff_parameter_standardize15",
  "postive_negative_efficacy15",
  "efficacy15_level",
  "efficacy16",
  "eff_parameter16",
  "eff_parameter_standardize16",
  "postive_negative_efficacy16",
  "efficacy16_level",
  "efficacy17",
  "eff_parameter17",
  "eff_parameter_standardize17",
  "postive_negative_efficacy17",
  "efficacy17_level",
  "efficacy18",
  "eff_parameter18",
  "eff_parameter_standardize18",
  "postive_negative_efficacy18",
  "efficacy18_level",
  "efficacy19",
  "eff_parameter19",
  "eff_parameter_standardize19",
  "postive_negative_efficacy19",
  "efficacy19_level",
  "efficacy20",
  "eff_parameter20",
  "eff_parameter_standardize20",
  "postive_negative_efficacy20",
  "efficacy20_level",
  "effect_on_color",
  "taste",
  "effect_on_taste",
  "phase",
  "other_technofunctionality",
  "other_technofunctionality_alt",
  "link",
  "first_author",
  "authors",
  "year",
  "journal",
  "volume_and_issue",
  "title",
  "short_link",
  "abstract",
];

export const foamHeaders = [
  "code",
  "technofunctionality",
  "ingredient",
  "ingredient_note",
  "suppliers",
  "source_category",
  "sector",
  "product_platform",
  "chemical_composition",
  "chemical_structure",
  "chemical_name_iupac",
  "chemical_composition_standardized",
  "extraction_yield_note",
  "extraction_yield_percentage",
  "extraction_yield",
  "solubility_note",
  "solubility_category",
  "solubility_in_water",
  "polarity",
  "stability_ph_note",
  "stability_ph_standardized",
  "stability_temperature_note",
  "stability_temperature_standardized",
  "stability_light",
  "stability_low_concentration",
  "stability_high_concentration",
  "stability_unit",
  "optimal_amount",
  "low_concentration",
  "low_quantity",
  "high_concentration",
  "high_quantity",
  "quantity_in_what",
  "product_type_beta",
  "optimal_concentration",
  "optimal_quantity",
  "substitution_percentage",
  "test_method",
  "mechanism",
  "results_statement",
  "efficacy1_alt",
  "eff_parameter1_alt",
  "efficacy2_alt",
  "eff_parameter2_alt",
  "efficacy3_alt",
  "eff_parameter3_alt",
  "efficacy",
  "efficacy_parameter",
  "efficacy_range",
  "efficacy1",
  "eff_parameter1",
  "efficacy1_classification",
  "efficacy1_amount",
  "efficacy1_range_amount",
  "efficacy2",
  "eff_parameter2",
  "efficacy2_conditions",
  "efficacy2_classification",
  "efficacy2_amount",
  "efficacy2_range_amount",
  "efficacy3",
  "eff_parameter3",
  "efficacy3_classification",
  "efficacy3_amount",
  "efficacy3_range_amount",
  "efficacy4",
  "eff_parameter4",
  "efficacy4_classification",
  "efficacy4_amount",
  "efficacy4_range_amount",
  "effect_on_taste",
  "phase",
  "other_technofunctionality",
  "link",
  "first_author",
  "authors",
  "year",
  "journal",
  "volume_and_issue",
  "title",
  "short_link",
  "abstract",
  "notes",
];

export const gellingHeaders = [
  "code",
  "technofunctionality",
  "ingredient",
  "ingredient_note",
  "form",
  "purity",
  "suppliers",
  "source_category",
  "sector",
  "product_platform",
  "application",
  "product_type_alpha",
  "chemical_composition",
  "chemical_composition_standardized",
  "chemical_structure",
  "chemical_name_iupac",
  "extraction_yield_note",
  "extraction_yield_percentage",
  "solubility_note",
  "solubility_category",
  "solubility_in_water",
  "polarity",
  "stability_ph_notes",
  "stability_ph_standardized",
  "viscosity",
  "stability_temperature_note",
  "stability_temperature_standardized",
  "stability_light",
  "stability_low_concentration",
  "stability_high_concentration",
  "stability_unit",
  "low_concentration",
  "high_concentration",
  "quantity_in_what",
  "product_type_beta",
  "optimal_concentration",
  "optimal_quantity_in_what",
  "product_type_gamma",
  "test_method",
  "efficacy_properties",
  "results_statement",
  "microorganism",
  "group_of_microorganisms",
  "efficacy1",
  "eff_parameter1",
  "efficacy1_level",
  "efficacy1_unit",
  "efficacy1_parameter",
  "efficacy2",
  "eff_parameter2",
  "efficacy2_level",
  "efficacy2_unit",
  "efficacy2_parameter",
  "efficacy3",
  "eff_parameter3",
  "efficacy3_level",
  "efficacy3_unit",
  "efficacy3_parameter",
  "efficacy4",
  "eff_parameter4",
  "efficacy4_level",
  "efficacy4_unit",
  "efficacy4_parameter",
  "efficacy5",
  "eff_parameter5",
  "efficacy5_level",
  "efficacy5_unit",
  "efficacy5_parameter",
  "efficacy6",
  "eff_parameter6",
  "efficacy6_level",
  "efficacy6_unit",
  "efficacy6_parameter",
  "effect_on_taste",
  "taste",
  "phase",
  "other_technofunctionality",
  "link",
  "first_author",
  "authors",
  "year",
  "journal",
  "volume_and_issue",
  "title",
  "short_link",
  "abstract",
];

export const defaultHeaders = () => {
  const allHeaders = [
    emulsifiantsHeaders,
    antimicrobienHeaders,
    antioxidantHeaders,
    sugarHeaders,
    fatHeaders,
    foamHeaders,
    gellingHeaders,
  ];

  // Flatten the array of arrays
  const flattenedHeaders = allHeaders.flatMap((array) => array);

  // Convert the flattened array into a Set to remove duplicates
  const uniqueHeaders = [...new Set(flattenedHeaders)];

  return uniqueHeaders;
};
